import React, { useEffect, useState } from "react";
import { ASSETS_URL, POCKET_BASE_URL } from "../../utils/config";

const BirthdayCard = ({ birthdayList }: { birthdayList: any[] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!birthdayList || birthdayList.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % birthdayList.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [birthdayList]);

  const user = birthdayList[currentIndex];
  console.log(user);

  return (
    <div className="flex sm:justify-center w-full sm:w-[40%] h-full px-2">
      <div
        className="w-full h-[500px] rounded-xl overflow-hidden relative transition-all duration-500 ease-in-out p-4 sm:p-6"
        style={{
          backgroundImage: "url(assets/birth.svg)",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="relative text-center flex flex-col justify-center h-full max-w-full overflow-hidden">
          <h1 className="text-xl sm:text-3xl font-bold text-red-600 mb-2 break-words">
            Happy Birthday!
          </h1>

          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 sm:w-28 sm:h-28 rounded-full overflow-hidden">
              <img
                src={
                  user?.profilePic
                    ? `${ASSETS_URL}${user.profilePic}`
                    : user?.userId
                      ? `${POCKET_BASE_URL}${user?.userId}`
                      : user?.name
                        ? "assets/user-4.svg"
                        : "assets/images.png"
                }
                alt={user?.name}
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).src = "assets/user-4.svg";
                }}
              />
            </div>
          </div>

          <h2 className="text-lg sm:text-base font-semibold text-gray-900 mb-1 break-words px-2">
            {user?.name}
          </h2>

          <p className="text-xs sm:text-sm text-gray-700 mb-2 break-words px-4 leading-snug">
            {(user?.department ? `${user?.department}, ` : "") +
              (user?.country || "")}
          </p>

          <p
            className="text-gray-600 text-xs sm:text-sm leading-relaxed px-4 break-words text-center"
            style={{
              maxWidth: "90%",
              margin: "0 auto",
              wordBreak: "break-word",
              whiteSpace: "normal",
              lineHeight: "1.4",
            }}
          >
            Wishing you a wonderful year ahead <br /> filled with happiness and
            success!
          </p>
        </div>
      </div>
    </div>
  );
};

export default BirthdayCard;
